import { useEffect, useState } from "react"
import { SpinnerText } from "../components/ui/Spinner"
import { useNavigate } from "react-router-dom"
import AppLayout from "../layout/AppLayout"

export default function VerifyPage() {
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(window.location.search)
  const status = queryParams.get("status")
  const email = queryParams.get("email") || localStorage.getItem("pendingEmail")

  const [resendMessage, setResendMessage] = useState("")

  useEffect(() => {
    if (status === "success" || status === "already") {
      setTimeout(() => navigate("/login"), 3000)
    }
  }, [status, navigate])

  const resendEmail = async () => {
    if (!email) {
      setResendMessage("No email address found")
      return
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users/resend-verification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      })

      if (!res.ok) throw new Error()
      setResendMessage("A new verification email has been sent. Please check your inbox.")
    } catch {
      setResendMessage("Error sending the verification email.")
    }
  }

  return (
    <AppLayout>
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex flex-col items-center gap-6 p-12 bg-white border border-gray-300 rounded-2xl shadow-md text-center max-w-md">
          {status === "success" && (
            <p>
              Account successfully verified. <br />
              You can now log in. <br />
              <SpinnerText>Redirecting shortly...</SpinnerText>
            </p>
          )}

          {status === "already" && (
            <p>
              Your account is already verified. <br />
              <SpinnerText>Redirecting to login...</SpinnerText>
            </p>
          )}

          {status === "error" && (
            <p>
              Verification failed. <br />
              Please request a new link.
            </p>
          )}

          {status === "resend" && (
            <>
              <p>
                Your account has not been verified yet. <br />
                Please request a new verification link.
              </p>
              <button
                onClick={resendEmail}
                className="w-56 px-6 py-3 bg-white text-black border border-gray-300 rounded-lg shadow-sm hover:bg-orange-100 transition-all duration-200"
              >
                Resend verification link
              </button>
              {resendMessage && <p>{resendMessage}</p>}
            </>
          )}
        </div>
      </div>
    </AppLayout>
  )
}
